import { GraphQLResult } from '@aws-amplify/api';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';
import { DocumentNode, GraphQLError } from 'graphql';
import { useEffect, useRef, useState } from 'react';
import api from '../services/api';

function useQuery<TResult>(
  query: string | DocumentNode,
  options: Omit<GraphQLOptionsV6<TResult, string>, 'query'>,
  instant?: boolean,
) {
  const [data, setData] = useState<TResult>();
  const [error, setError] = useState<GraphQLError[]>();
  const [loading, setLoading] = useState(true);
  const count = useRef(0);

  function loadData() {
    count.current = +1;

    (
      api.graphql({
        ...options,
        query,
      }) as Promise<GraphQLResult<TResult>>
    )
      .then((result) => {
        if (result.data) {
          setData({
            ...(result.data as TResult),
          });
        }

        if (result.errors) {
          setError(result.errors);
        }
      })
      .catch(() => {
        setError([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  // Load data on load
  useEffect(() => {
    if (instant === undefined) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Load data if instant trigger is set
  useEffect(() => {
    if (instant && count.current === 0) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instant]);

  return {
    data,
    error,
    loading,
  };
}

export default useQuery;
